export default __webpack_public_path__ + "static/media/clouded.91af8b7e.png";